import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p><strong>Description</strong></p>
     <p>Stow compliance is critical in ensuring that we are hitting our network goal of 95% stow compliance in station, and to ensure that we are reducing the amount return packages that are unreconciled (URR).</p>
     <p><strong>Resolution Steps:</strong></p>
     <ol>
        <li>Navigate to SCC to identify any packages that have been RTS and not stowed > 1 day</li>
        <ul>
            <li>Package Summary →Ageing</li>
            <ul>
                <li>Reverse leg</li>
                <li>Shipment Type SWA / Customer Returns / Undeliverables</li>
            </ul>
        </ul>
        <li>Confirm that all URL volume is stowed in containers, such as shuttles or pallets, not Go-Carts. Reverse Centers cannot process volume in Go-Carts.</li>
     </ol>
     <p><strong>Supplemental Links</strong></p>
     <ol>
        <li><span class="wikiinternallink"><a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjI2MDIzIg%3D%3D&businessUnitId=IjMi&selectedTagValueIds=WyIzMDMiLCIzMzIwIiwiMzMyMiJd&topLevelFilters=eyI0IjoiNDEiLCI2IjoiNDkifQ%3D%3D#26023">Reverse Logistics URL START Page</a></span></li>
        <li><span class="wikiinternallink"><a href="https://w.amazon.com/bin/view/NA_AMZL_ACES/LMDX/Reverse_Logistics">Reverse Logistics URL WIKI</a></span></li>
     </ol>
     <p><strong>RACI</strong></p>
     <img src="https://w.amazon.com/bin/download/Stratos/Internal/MBEDashboard/ExceptionSOP/AMZLStations_Multiday_Stow_Alert/WebHome/Screenshot%202024-11-14%20at%201.36.45%E2%80%AFPM.png?width=1162&height=401" alt="RACI" />
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Multiday_Stow_Alert.jsx